module.exports = __webpack_public_path__ + "img/DSC_2763-xs.a2ff37b6.png";